var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "fixed-grid mx-2 has-1-cols quote-builder-cells-holder",
        class: {
          // when in multi column view (dropdown view), only have two columns if screen is atleast 1024px or cant see some items
          "has-1-cols":
            _vm.selectedViewType == _vm.viewTypes.singleColView ||
            _vm.selectedViewType == _vm.viewTypes.tabbedView,
          "has-2-cols-desktop":
            _vm.selectedViewType == _vm.viewTypes.multiColView,
        },
      },
      [
        _c("div", { staticClass: "grid mb-4" }, [
          _c("div", { staticClass: "cell" }, [
            _vm.selectedTab.type == _vm.ItemCategoryTypes.RR ||
            _vm.selectedTab.type == _vm.ItemCategoryTypes.REP ||
            _vm.selectedTab.type == _vm.ItemCategoryTypes.PAINT ||
            _vm.selectedViewType != _vm.viewTypes.tabbedView
              ? _c(
                  "div",
                  { staticClass: "quote-items-section labour mb-4" },
                  [
                    _c("quote-builder-labour-component", {
                      attrs: {
                        value: _vm.value,
                        "selected-tab": _vm.selectedTab,
                        "is-full-width": _vm.isFullWidth,
                        "view-types": _vm.viewTypes,
                        vehicle: _vm.vehicle,
                        "edit-item-obj": _vm.editItemObj,
                        "selected-view-type": _vm.selectedViewType,
                        "next-line-number": _vm.nextLineNumberValue,
                        "is-audanet":
                          _vm.value.isAudaNet || _vm.value.isAudaBridge,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        handleUpdate: (newVal) =>
                          _vm.$emit("handleUpdate", newVal),
                        onOpgCodeChanged: function ($event) {
                          return _vm.$emit("onOpgCodeChanged")
                        },
                        onItemCopied: _vm.onItemCopied,
                        focusNextRow: (item) => _vm.handleFocusNextRow(item),
                        newItemAdded: (item) => _vm.newItemAdded(item, true),
                        handleItemRowClick: _vm.handleItemRowClick,
                        itemRowClicked: _vm.handleItemRowClick,
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        onItemDeleted: (lineNum) =>
                          _vm.handleDeletedItemNotification(lineNum),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedTab.type == _vm.ItemCategoryTypes.MECH ||
            _vm.selectedViewType != _vm.viewTypes.tabbedView
              ? _c(
                  "div",
                  { staticClass: "quote-items-section other mb-4" },
                  [
                    _c("quote-builder-other-labour-component", {
                      attrs: {
                        value: _vm.value,
                        "selected-tab": _vm.selectedTab,
                        "is-full-width": _vm.isFullWidth,
                        "view-types": _vm.viewTypes,
                        vehicle: _vm.vehicle,
                        "edit-item-obj": _vm.editItemObj,
                        "selected-view-type": _vm.selectedViewType,
                        "is-audanet":
                          _vm.value.isAudaNet || _vm.value.isAudaBridge,
                        "next-line-number": _vm.nextLineNumberValue,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        handleUpdate: (newVal) =>
                          _vm.$emit("handleUpdate", newVal),
                        onItemCopied: _vm.onItemCopied,
                        focusNextRow: (item) => _vm.handleFocusNextRow(item),
                        newItemAdded: (item) => _vm.newItemAdded(item, true),
                        handleItemRowClick: _vm.handleItemRowClick,
                        itemRowClicked: _vm.handleItemRowClick,
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        onItemDeleted: (lineNum) =>
                          _vm.handleDeletedItemNotification(lineNum),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "cell" }, [
            _vm.selectedTab.type == _vm.ItemCategoryTypes.PART ||
            _vm.selectedViewType != _vm.viewTypes.tabbedView
              ? _c(
                  "div",
                  { staticClass: "quote-items-section parts mb-4" },
                  [
                    _c("quote-builder-part-component", {
                      attrs: {
                        value: _vm.value,
                        "selected-tab": _vm.selectedTab,
                        "is-full-width": _vm.isFullWidth,
                        "view-types": _vm.viewTypes,
                        "edit-item-obj": _vm.editItemObj,
                        "selected-view-type": _vm.selectedViewType,
                        vehicle: _vm.vehicle,
                        "next-line-number": _vm.nextLineNumberValue,
                        "is-editable": !_vm.readOnlyComputed,
                        "is-audanet":
                          _vm.value.isAudaNet || _vm.value.isAudaBridge,
                      },
                      on: {
                        handleUpdate: (newVal) =>
                          _vm.$emit("handleUpdate", newVal),
                        onItemCopied: _vm.onItemCopied,
                        focusNextRow: (item) => _vm.handleFocusNextRow(item),
                        newItemAdded: (item) => _vm.newItemAdded(item, true),
                        handleItemRowClick: _vm.handleItemRowClick,
                        itemRowClicked: _vm.handleItemRowClick,
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        onItemDeleted: (lineNum) =>
                          _vm.handleDeletedItemNotification(lineNum),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedTab.type == _vm.ItemCategoryTypes.MISC ||
            _vm.selectedViewType != _vm.viewTypes.tabbedView
              ? _c(
                  "div",
                  { staticClass: "quote-items-section misc mb-4" },
                  [
                    _c("quote-builder-misc-component", {
                      attrs: {
                        value: _vm.value,
                        "selected-tab": _vm.selectedTab,
                        "is-full-width": _vm.isFullWidth,
                        "view-types": _vm.viewTypes,
                        "edit-item-obj": _vm.editItemObj,
                        "selected-view-type": _vm.selectedViewType,
                        vehicle: _vm.vehicle,
                        "next-line-number": _vm.nextLineNumberValue,
                        "is-audanet":
                          _vm.value.isAudaNet || _vm.value.isAudaBridge,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        handleUpdate: (newVal) =>
                          _vm.$emit("handleUpdate", newVal),
                        onItemCopied: _vm.onItemCopied,
                        focusNextRow: (item) => _vm.handleFocusNextRow(item),
                        newItemAdded: (item) => _vm.newItemAdded(item, true),
                        handleItemRowClick: _vm.handleItemRowClick,
                        itemRowClicked: _vm.handleItemRowClick,
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        onItemDeleted: (lineNum) =>
                          _vm.handleDeletedItemNotification(lineNum),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedTab.type == _vm.ItemCategoryTypes.SUBL ||
            _vm.selectedViewType != _vm.viewTypes.tabbedView
              ? _c(
                  "div",
                  { staticClass: "quote-items-section sublets" },
                  [
                    _c("quote-builder-sublet-component", {
                      attrs: {
                        value: _vm.value,
                        "selected-tab": _vm.selectedTab,
                        "is-full-width": _vm.isFullWidth,
                        "view-types": _vm.viewTypes,
                        "edit-item-obj": _vm.editItemObj,
                        "selected-view-type": _vm.selectedViewType,
                        vehicle: _vm.vehicle,
                        "is-audanet":
                          _vm.value.isAudaNet || _vm.value.isAudaBridge,
                        "next-line-number": _vm.nextLineNumberValue,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        handleUpdate: (newVal) =>
                          _vm.$emit("handleUpdate", newVal),
                        onItemCopied: _vm.onItemCopied,
                        focusNextRow: (item) => _vm.handleFocusNextRow(item),
                        newItemAdded: (item) => _vm.newItemAdded(item, true),
                        handleItemRowClick: _vm.handleItemRowClick,
                        itemRowClicked: _vm.handleItemRowClick,
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        onItemDeleted: (lineNum) =>
                          _vm.handleDeletedItemNotification(lineNum),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }